import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { isEverbridgeFlowDesignerApp } from 'selectors/featureToggles';
import XmattersHelpSearch from './XmattersHelpSearch';
import EBFDHelpSearch from './EBFDHelpSearch';

/**
 * Our internal xmatters search uses swiftype to include results in our own UI.
 * This is done via `XmattersHelpSearch` and similar.
 *
 * However there is no such setup for Everbridge Flow Designer at the moment,
 * so EBFD search redirects users to the EBFD Help search page when user hits ENTER.
 *
 * Hopefully one day all our apps can have shared search UX.
 */
export default function HelpSearchWrapper({
  contentRef,
  iframeSrc,
  setHelpLocation,
}) {
  if (useSelector(isEverbridgeFlowDesignerApp)) {
    return (
      <EBFDHelpSearch iframeSrc={iframeSrc} setHelpLocation={setHelpLocation} />
    );
  }
  return (
    <XmattersHelpSearch
      contentRef={contentRef}
      setHelpLocation={setHelpLocation}
    />
  );
}

HelpSearchWrapper.displayName = 'HelpSearchWrapper';
HelpSearchWrapper.propTypes = {
  contentRef: PropTypes.object.isRequired,
  setHelpLocation: PropTypes.func.isRequired,
};
